import {
  Avatar,
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  CardActions,
  ListBase,
  Loading,
  useAuthenticated,
  useListContext,
  useTranslate,
} from "react-admin";
import { getLocalDate, getLocalTime } from "../../../utils/";
import { useEffect, useState } from "react";

import MemberInfoPanel from "../../../components/MemberInfoPanel";
import Phone from "../../../components/Phone";
import PointIcon from "../../../assets/icons/point.png";
import RestoreIcon from "@material-ui/icons/Restore";
import SearchBarwithButton from "../../../components/SearchBarwithButton";
import SfBreadcrumb from "../../../components/SfBreadcrumbs";
import TierMedal from "../../../components/TierMedal";
import { isLiteVersion } from "../../../utils/settings";
import useCheckPermission from "../../../hooks/useCheckPermission";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    position: "relative",
    top: 0,
    bottom: 0,
    height: "100%",
  },
  title: theme.title,
  breadcrumb: {
    alignSelf: "start",
  },
  leftPanel: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 0 auto",
  },
  rightPanel: {
    backgroundColor: theme.white,
    overflowY: "auto",
  },
  dataGrid_rowEven: {
    backgroundColor: "gray", //Not work
  },
  dataGrid_rowOdd: {
    backgroundColor: "red", //Not work
  },

  proceedButtonContainer: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    maxWidth: 682,
    height: 99,
    display: "flex",
    justifyContent: "center",
    position: "fixed",
    bottom: "0",
  },
  spaceforProceedButton: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    height: 99,
    display: "flex",
    justifyContent: "center",
    //width: "100%",
  },
  proceedButton: {
    width: 322,
    height: 57,
    fontSize: 28,
    fontWeight: "bold",
    alignSelf: "center",
  },

  searchButton: {
    borderRadius: 12,
  },
}));

const PaymentSearchMember = (props) => {
  useAuthenticated();
  const classes = useStyles();
  const [memberInfo, setMemberInfo] = useState();
  const history = useHistory();
  const [foundUser, setFoundUser] = useState(false);
  const translate = useTranslate();
  const { checkWritePermission } = useCheckPermission();
  const [allowTomakePayment, setAllowTomakePayment] = useState(false);

  async function checkData() {
    const allowTomakePayment = await checkWritePermission(
      "Page.Merchant.Payment"
    );
    setAllowTomakePayment(allowTomakePayment);
  }
  useEffect(() => {
    checkData();
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid className={classes.allContainer} container>
      <Grid item xs={8} className={classes.leftPanel}>
        <SfBreadcrumb path="/Payment/Member" className={classes.breadcrumb} />
        <Box
          style={{
            width: "100%",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography className={classes.title} style={{ marginTop: 20 }}>
            {translate("ra.text.memberSearch.findMember")}
          </Typography>

          <ListBase
            {...props}
            resource="members"
            basePath="/payment/search-member"
            bulkActionButtons={false}
            perPage={20}
            actions={<NoneActions />}
            style={{ width: "100%" }}
            //  sort={null}
            sort={{ field: "None", order: "DSC" }}
          >
            <Search />
            <Typography
              style={{ marginTop: "20px", marginBottom: 20, fontSize: 20 }}
            >
              {translate("ra.text.memberSearch.selectaMember")}
            </Typography>
            <MyDatagrid
              memberInfo={memberInfo}
              setMemberInfo={setMemberInfo}
              setFoundUser={setFoundUser}
            ></MyDatagrid>
          </ListBase>
          {foundUser ? (
            <Box className={classes.proceedButtonContainer}>
              <Button
                className={classes.proceedButton}
                variant="contained"
                color="primary"
                disabled={(memberInfo ? false : true) || !allowTomakePayment}
                onClick={() =>
                  history.push({
                    //pathname: "/payment/member-mainmenu"
                    pathname: isLiteVersion()
                      ? "/payment/lite"
                      : "/payment/addproduct",
                    state: { member: memberInfo },
                  })
                }
              >
                {translate("ra.text.proceed")}
              </Button>
            </Box>
          ) : null}
          <Box className={classes.spaceforProceedButton}></Box>
        </Box>
      </Grid>
      <Grid item xs={4} className={classes.rightPanel}>
        {memberInfo ? <MemberInfoPanel id={memberInfo.id} /> : null}
      </Grid>
    </Grid>
  );
};
const NoneActions = () => <CardActions />;

const handleClickMember = (record, setMemberInfo) => {
  setMemberInfo({ ...record });
};

const Search = () => {
  const { setFilters, filterValues } = useListContext();
  const [, setSearchText] = useState();
  const translate = useTranslate();
  return (
    <SearchBarwithButton
      onChange={(e) => {
        if (e.target.value === "") {
          const newFilterValues = { ...filterValues };
          delete newFilterValues.keyword;
          setFilters(newFilterValues);
        } else {
          setFilters({ ...filterValues, keyword: e.target.value });
        }
        setSearchText(e.target.value);
      }}
      buttonLabel={translate("ra.text.search")}
      placeholder={translate("ra.text.memberSearch.searchMember")}
      onSearch={null}
    />
  );
};

const useMyDataGridStyles = makeStyles((theme) => ({
  tableContainer: {
    flexGrow: 1,
    flexBasis: 100,
    overflowY: "scroll",
  },
  loadingContainer: {
    flexGrow: 1,
    flexBasis: 100,
    overflowY: "none",
  },

  rowContainer: {
    backgroundColor: theme.white,
  },
  rowContainer_selected: {
    backgroundColor: theme.lightOrange,
  },
  rowHeight: {
    maxHeight: 68,
    paddingTop: 5,
    paddingBottom: 5,
    height: 68,
    boxSizing: "border-box",
    paddingLeft: 10,
    paddingRight: 10,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  fullname: { ...theme.h7 },
  restoreIcon: {
    height: 27,
    width: 27,
    color: theme.darkGray,
  },
  time_text: { fontSize: 14 },
  point: {
    fontSize: 14,
    marginLeft: 4,
    color: theme.orange,
  },
  pointIcon: {
    width: 25,
    height: 25,
  },
  selectButton: {
    width: 60,
    height: 30,
  },
  transparent: {
    backgroundColor: "transparent",
  },
  gray: {
    backgroundColor: "rgba(235, 235, 235, 0.8)",
  },
  tags_text: {
    fontSize: 14,
    width: 100,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": 2,
  },
}));

const MyDatagrid = ({ memberInfo, setMemberInfo, setFoundUser }) => {
  const { data, ids, loading } = useListContext();
  const classes = useMyDataGridStyles();
  const { setFilters } = useListContext();
  const translate = useTranslate();
  useEffect(() => {
    setFilters({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (loading) return <Loading className={classes.loadingContainer} />;

  setFoundUser(ids.length > 0 && data !== null);
  return (
    <TableContainer className={classes.tableContainer}>
      <Table classes={{ root: classes.transparent }}>
        <TableBody classes={{ root: classes.transparent }}>
          {ids.length > 0 ? (
            <>
              {ids.map((id, index) => {
                const record = data[id];
                //const id = record.id;
                return (
                  <TableRow
                    key={id}
                    role="checkbox"
                    classes={{
                      root:
                        index % 2 === 0 ? classes.transparent : classes.gray,
                    }}
                    onClick={() => handleClickMember(record, setMemberInfo)}
                    selected={memberInfo ? id === memberInfo.id : false}
                  >
                    {/* first column: selection checkbox */}

                    <TableCell className={classes.rowHeight}>
                      <TierMedal
                        image={record.tier.current.image_url}
                        name={record.tier.current.name}
                      />
                    </TableCell>
                    <TableCell className={classes.rowHeight}>
                      <Typography className={classes.fullname} noWrap>
                        {record.firstname} {record.lastname}
                      </Typography>

                      <Phone number={record.phone} />
                    </TableCell>
                    <TableCell className={classes.rowHeight}>
                      <Typography className={classes.tags_text}>
                        {record?.tags?.map((tag) => "#" + tag).join(", ")}
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.rowHeight}>
                      <Box className={classes.flexRow}>
                        <RestoreIcon
                          className={classes.restoreIcon}
                        ></RestoreIcon>
                        <Box>
                          <Typography className={classes.time_text}>
                            {getLocalDate(record.last_transaction_time)}
                          </Typography>
                          <Typography className={classes.time_text}>
                            {getLocalTime(record.last_transaction_time)}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell className={classes.rowHeight}>
                      <Box className={classes.flexRow}>
                        <Avatar src={PointIcon} className={classes.pointIcon} />
                        <Typography className={classes.point}>
                          {Number(
                            record.lifetime_value?.remaining_reward ?? 0
                          ).toLocaleString()}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell className={classes.rowHeight}>
                      <Button
                        className={classes.selectButton}
                        disabled={
                          memberInfo
                            ? id === memberInfo.id
                              ? true
                              : false
                            : false
                        }
                        variant="contained"
                        color="primary"
                      >
                        {translate("ra.text.select")}
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </>
          ) : (
            <NotFoundView />
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const useNotFoundViewStyles = makeStyles((theme) => ({
  allContainer: {
    backgroundColor: theme.layoutBackground,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  redText: {
    marginTop: 17,
    color: theme.red,
    marginLeft: 72,
    marginRight: 72,
  },
  registerTitle: {
    marginTop: 93,
  },
  registerButton: { marginTop: 26, width: 322, height: 57, fontSize: 28 },
  or: {
    marginTop: 40,
  },
  addPaymentTitle: {
    marginTop: 24,
  },
  addPaymentButton: {
    marginTop: 14,
    width: 322,
    height: 57,
    fontSize: 28,
  },
}));

const NotFoundView = () => {
  const classes = useNotFoundViewStyles();
  const history = useHistory();
  return (
    <Box className={classes.allContainer}>
      <Typography className={classes.redText} align="center">
        We cannot find this name. Please try again with phone number or register
        for new member
      </Typography>
      <Typography className={classes.registerTitle} align="center">
        Could not find the member? Register for new member here
      </Typography>
      <Button
        className={classes.registerButton}
        variant="contained"
        color="primary"
        onClick={() => history.push("/customers/register")}
      >
        Register
      </Button>
      <Typography className={classes.or} align="center">
        OR
      </Typography>
      <Typography className={classes.addPaymentTitle} align="center">
        Proceed with non-member
      </Typography>
      <Button
        className={classes.addPaymentButton}
        variant="contained"
        color="primary"
        onClick={() =>
          history.push({
            pathname: isLiteVersion() ? "/payment/lite" : "/payment/addproduct",
            state: { memberInfo: null },
          })
        }
      >
        Add Payment
      </Button>
    </Box>
  );
};

export default PaymentSearchMember;
